import React from 'react';
import './SwitchToggle.css';

const SwitchToggle = ({ isEnabled, onToggle, label }) => {
  return (
    <div className="switch-toggle-container">
      <label className="switch">
        <input
          type="checkbox"
          checked={isEnabled}
          onChange={onToggle}
        />
        <span className="slider"></span>
      </label>
      {label && <span className="switch-label">{label}</span>}
    </div>
  );
};

export default SwitchToggle; 